export default __webpack_public_path__ + "images/b4e0fe469a6f2e29aff426030e8fa703-do_9.png";